import {
  ioGetReceivedEmailList,
  ioGetReceivedEmailContent
} from '@/febos/servicios/api/emails.api';

export const getReceivedEmailsList = async ({ commit }, {
  query = {},
  sort = [{ timestamp: { order: 'desc', missing: '_last' } }],
  page = 1,
  itemsPerPage = 10
}) => {
  try {
    commit('SET_LOADING', true);
    const from = (page - 1) * itemsPerPage;
    const size = itemsPerPage;
    const { data: { data: { hits: { hits, total } } } } = await ioGetReceivedEmailList({
      body: { query, sort, from, size }
    });
    commit('SET_RECEIVED_EMAILS_LIST', {
      pages: Math.ceil(total.value / itemsPerPage),
      itemsPerPage,
      emails: hits
    });
  } finally {
    commit('SET_LOADING', false);
  }
};

export const viewEmailContent = async ({ commit }, { email }) => {
  commit('SET_SELECTED_EMAIL', email);
  commit('SET_SHOW_EMAIL_VIEWER', true);
};

export const closeEmailViewer = ({ commit }) => {
  commit('SET_SHOW_EMAIL_VIEWER', false);
  commit('SET_SELECTED_EMAIL', null);
};

export const movePage = async ({ commit }, page) => {
  commit('SET_PAGE', { page });
};

export const changeItemPerPage = async ({ commit }, items) => {
  commit('SET_ITEM_PER_PAGE', { items, page: 1 });
};
